import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M17 8a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M3 11a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M13 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M6.5 9.5l3.5 -3","key":"svg-4"}],["path",{"d":"M14 5.5l3 1.5","key":"svg-5"}],["path",{"d":"M18.5 10l-2.5 7","key":"svg-6"}],["path",{"d":"M13.5 17.5l-7 -5","key":"svg-7"}]]

const IconPolygon = createReactComponent('outline', 'polygon', 'Polygon', __iconNode);

export default IconPolygon;